import React, { createContext, useState } from "react";

const DatagridContext = createContext();

export const DatagridProvider = ({ children }) => {
  const [url, setUrl] = useState("");
  const [from, setFrom] = useState("");
  const [headerQuery, setHeaderQuery] = useState("");
  const [status, setStatus] = useState(null);

  setUrl(url);
  setFrom(from);
  setHeaderQuery(headerQuery);
  return (
    <DatagridContext.Provider
      value={{
        url,
        from,
        status,
        setStatus,
        headerQuery,
      }}
    >
      {children}
    </DatagridContext.Provider>
  );
};

export default DatagridContext;
